module.exports = __webpack_public_path__ + "static/Logo_duefocus1-ea715aebb25b75f3d14f1a2babe3b06b.svg";